export const PLAN_FREE = 'free'

export const OLD_MAGIC_UNLIMITED_NUMBER = 10_000
export const MAGIC_UNLIMITED_NUMBER = -1

export function isUnlimited(num) {
  return num == OLD_MAGIC_UNLIMITED_NUMBER || num == MAGIC_UNLIMITED_NUMBER
}

export function isPaidPlan(plan) {
  return plan.monthlyPrice > 0.0
}

export function isUpgrade(currentPlan, newPlan) {
  return currentPlan.monthlyPrice < newPlan.monthlyPrice
}

export function isDowngrade(currentPlan, newPlan) {
  return currentPlan.monthlyPrice > newPlan.monthlyPrice
}
